export default (img) => {
  const favicon = document.getElementById('favicon');
  if(img && favicon) {
    favicon.href = img
  }
}
